/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Flag_No_WeightInputs */

const en_flag_no_weight = /** @type {(inputs: Flag_No_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Amount?`)
};

const de_flag_no_weight = /** @type {(inputs: Flag_No_WeightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menge?`)
};

/**
* | output |
* | --- |
* | "Amount?" |
*
* @param {Flag_No_WeightInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const flag_no_weight = /** @type {((inputs?: Flag_No_WeightInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Flag_No_WeightInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_flag_no_weight(inputs)
	return en_flag_no_weight(inputs)
});